import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgAddContact({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M21.535 20.135c4.121 0 7.456-3.385 7.456-7.567C28.991 8.385 25.656 5 21.535 5c-4.12 0-7.456 3.385-7.456 7.568 0 4.182 3.335 7.567 7.456 7.567Z"
                fill="#297A71"
            />
            <path
                d="M21.534 7.162c2.936 0 5.326 2.426 5.326 5.406 0 2.98-2.39 5.405-5.326 5.405-2.936 0-5.326-2.426-5.326-5.405 0-2.98 2.39-5.406 5.326-5.406Z"
                fill="#297A71"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.458 21.647a4.49 4.49 0 0 0-.37 1.788v3.687h-3.686l-.22.007-.167.011-.22.023a4.507 4.507 0 0 0-3.9 4.465l.009.275a4.501 4.501 0 0 0 1.842 3.367h-9.798c-1.764 0-3.195-1.453-3.195-3.244V29c0-1.608.48-3.101 1.305-4.344 1.378-2.075 3.728-3.17 6.144-3.17 1.073 0 1.757.19 2.465.385.759.21 1.545.427 2.868.427s2.109-.217 2.868-.427c.707-.195 1.391-.384 2.464-.384.537 0 1.07.054 1.59.16Zm2.991 1.343a1.225 1.225 0 0 0-.083.445v6.964h-6.964l-.167.012a1.23 1.23 0 0 0 .167 2.446h6.964v2.403a3.189 3.189 0 0 0 2.458-1.504v-.899h.387c.069-.265.106-.543.106-.83v-1.628h-.493v-4.15a7.795 7.795 0 0 0-.812-1.594 6.85 6.85 0 0 0-1.563-1.665Z"
                fill="#297A71"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.089 23.778a5.787 5.787 0 0 0-1.222-.13c-.806 0-1.383.16-2.025.338-.806.223-1.714.474-3.308.474-1.591 0-2.5-.251-3.306-.474-.644-.177-1.223-.337-2.033-.337-1.817 0-3.455.831-4.373 2.216a5.673 5.673 0 0 0-.94 3.135v3.027c0 .595.48 1.081 1.066 1.081h8.196a4.492 4.492 0 0 1-.24-1.205l-.009-.274a4.507 4.507 0 0 1 3.9-4.466l.22-.022.167-.011.22-.008h3.687v-3.344Zm3.277 2.286c.532.88.813 1.894.813 2.936v3.027h.007c0 .51-.351.939-.82 1.052v-.221h-6.964a1.229 1.229 0 0 1-.167-2.447l.167-.011h6.964v-4.336Z"
                fill="#297A71"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.813 23.268a1.23 1.23 0 0 0-2.447.167V30.4h-6.964l-.167.01a1.23 1.23 0 0 0 .167 2.448h6.964v6.964l.012.167a1.23 1.23 0 0 0 2.447-.167v-6.964h6.964l.167-.011a1.23 1.23 0 0 0-.167-2.447h-6.965v-6.965l-.01-.167Z"
                fill="#297A71"
            />
            <path
                d="M21.534 7.162c2.936 0 5.326 2.426 5.326 5.406 0 2.98-2.39 5.405-5.326 5.405-2.936 0-5.326-2.426-5.326-5.405 0-2.98 2.39-5.406 5.326-5.406Z"
                fill="#297A71"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.089 23.779a5.787 5.787 0 0 0-1.222-.13c-.806 0-1.383.16-2.025.337-.806.223-1.714.474-3.308.474-1.591 0-2.5-.25-3.306-.473-.644-.178-1.223-.338-2.033-.338-1.817 0-3.455.831-4.373 2.217a5.673 5.673 0 0 0-.94 3.135v3.027c0 .594.48 1.08 1.066 1.08h8.196a4.492 4.492 0 0 1-.24-1.204l-.009-.275a4.507 4.507 0 0 1 3.9-4.465l.22-.023.167-.011.22-.007h3.687v-3.344Zm3.277 2.285c.532.881.813 1.895.813 2.937v3.027h.007c0 .509-.351.939-.82 1.052v-.222h-6.964a1.229 1.229 0 0 1-.167-2.447l.167-.011h6.964v-4.335Z"
                fill="#297A71"
            />
        </svg>
    )
}
SvgAddContact.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgAddContact
